<template>
    <div ref="initial-order-setup" id="initial-order-setup" class="is-relative is-full-height" v-resize.initial="handleInitialSetupResize">
        <div class="initial-order-body" v-if="!showLogin && $mq === 'desktop'">
            <div v-if="!choice" class="has-text-centered is-full-height">
                <!-- store has nothing yet -->
                <div v-if="!location.id">
                        <img alt="store logo image" class="modal-logo" src="../../../assets/store-logo.png"/>
                        <p v-if="!loggedIn" class="login-txt has-text-right-desktop is-pulled-right-desktop">
                            <span v-if="$mq !== 'mobile'">{{ $appConstants.loginInquiry }}<br> </span>
                            <b><a href="#login-signup" @click.prevent="triggerLogin" class="store-navigation-color">Login or Signup </a></b>
                        </p>
                    <div id="store-locator-section" class="margin-auto full-width-mobile">
                        <h3 class="is-size-3">
                            <b>{{(!loggedIn) ? "Login or" : ""}} Choose a Location</b>
                        </h3>

                        <store-locator :isStreamLined="true" />
                    </div>
                </div>
                <!-- verify delivery address -->
                <div class="modal-padding" v-else-if="showDeliverySection">
                    <address-verifier @locationVerified="handleRoute"/>
                    <a href="#back" id="back-txt" class="store-loyalty-color is-size-6-5" @click.prevent="restartModal">Back to store/order details</a>
                </div>
                <!-- choose service type, show location -->
                <div v-else-if="!showDeliverySection" class="service-type-section">
                    <div class="service-type-label">
                        <h4 class="is-size-4">Please Select</h4>
                    </div>

                    <div class="service-type-icons">
                        <service-type-chooser @service-type-changed="handleServiceTypeChange"/>
                        <div v-if="location.id" class="columns is-centered">
                            <div class="column is-6-desktop has-text-left location-detail-section">
                                <location-detail :location="location" @change-location="triggerStoreLocator" />
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
	import resize from 'vue-resize-directive';
	import EventBus from '@EventBus';
    import { ACCOUNT_CHECKOUT, LOCATION, ACCOUNT, FRANCHISOR } from '@/stores/defs';
    import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
    import { mapGetters } from 'vuex';
    import addressService from '@/services/address.service';
    import AddressVerifier from '@/components/orders/initial-order-setup/AddressVerifier';
    import ContentModal from "@ContentModal";
    import LocationDetail from '@/components/store-locator/LocationDetail';
    import LocationVerifier from '@/components/orders/initial-order-setup/LocationVerifier';
    import Login from '@/components/auth/Login';
	import modalMixin from '@/components/mixins/modalMixin';
    import ServiceTypeChooser from '@/components/checkout/ServiceTypeChooser';
	import StoreLocator from '@/components/store-locator/StoreLocator/StoreLocator';
	import navigationMixin from '@Mixin/navigationMixin';
	import routeMixin from '@Mixin/routeMixin';
	import serviceMixin from '@Mixin/serviceMixin';

    export default {
        mixins: [
			modalMixin,
			navigationMixin,
			routeMixin,
			serviceMixin,
		],
		directives: {
			resize,
		},
		props: {
            routeTo: {
                type: Object,
                default: null
            }
        },
        computed: {
            ...mapGetters({
                serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
                location: LOCATION.GET_LOCATION,
                guestAddress: ACCOUNT.GET_GUEST_ADDRESS,
                customer: ACCOUNT.GET_CUSTOMER,
                userSetServiceType: ACCOUNT_CHECKOUT.GET_USER_SET_SERVICE_TYPE,
                franchisor: FRANCHISOR.GET_FRANCHISOR,
                loggedIn: ACCOUNT.GET_LOGGED_IN
            })
        },
        components: {
            'address-verifier': AddressVerifier,
            'store-locator': StoreLocator,
            'service-type-chooser': ServiceTypeChooser,
            'location-detail': LocationDetail
        },
        data() {
            return {
                modalOverlay: null,
                choice: null,
                EServiceType: EServiceType,
                originalLocation: null,
                showLogin: false,
                showDeliverySection: false,
                showStoreLocator: false
            }
        },
        methods: {
            restartModal() {
                this.choice = null;
				this.showDeliverySection = false;
            },
            triggerStoreLocator() {
                this.triggerModal({
                    component: StoreLocator,
                    showCloseButton: true,
                    classes: "global-modal",
                    title: "Locations"
				});
            },
            handleServiceTypeChange(type) {
                if (type === EServiceType.SERVICE_TYPE_TAKEOUT && this.location.id) {
                     this.$modal.hide('contentModal');
                } else if (type === EServiceType.SERVICE_TYPE_DELIVERY && this.location.id && this.guestAddress) {
                    // verify if guest address is deliverable, if so, close modal
                    addressService.isAddressDeliverable(this.guestAddress, this.location.id)
                    .then((res) => {
                        if (res.data.body.is_deliverable) {
                            this.guestAddress.delivery = {
                                isDeliverable: res.data.body.is_deliverable,
                                price: parseInt(res.data.body.price)
                            }
                             this.$modal.hide('contentModal');
                        } else {
                            this.showDeliverySection = true;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                    this.$modal.hide('contentModal');
                } else if (type === EServiceType.SERVICE_TYPE_DELIVERY && this.location.id) {
                    this.showDeliverySection = true;
                }
            },
            handleRoute() {
                const sendRoute = () => {
                    if (this.location && this.location.id && this.originalLocation && this.originalLocation.id !== this.location.id) {
                        this.$router.push({name: this.routeTo.name, params: this.routeTo.params});
                    } else if (this.location && this.location.id  && this.originalLocation && this.originalLocation.id === this.location.id) {
                        //  same location, route to menu
                        this.$router.push({name: this.routeTo.name, params: this.routeTo.params});
                    }
                };

                if (this.location) {
                    if (this.serviceType === EServiceType.SERVICE_TYPE_TAKEOUT) {
                        // sendRoute();
                        this.$modal.hide('contentModal');
                    } else if (this.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
                        if (this.guestAddress) {
                            // sendRoute();
                            this.$modal.hide('contentModal');
                        }
                    }
                }
            },
            triggerLogin() {
				let path = `${this.$route.path}`;
				if (path === '/logout' || !path) {
					path = '/';
				}
                this.showLogin = true;
                this.triggerModal({
                    component: Login,
                    title: "Login",
                    classes: 'global-modal',
                    modalName: "loginModal",
                    contentProperties: {
                        routeTo: path,
                        loginNoStore: true
                    },
                    events: {
                        'before-close': () => {this.showLogin = false;}
                    }
                })
			},
			handleInitialSetupResize() {
				const atGreeting = this._isGreetingRoute;
				if (window.innerWidth <= 1088 && !atGreeting) {
					this._navigateToGreeting();
					this.$modal.hide('contentModal');
				}
			}
        },
        watch: {
            location: {
                handler(newLocation, before) {
					this.modalOverlay = document.querySelector(".v--modal-background-click");
                    if (newLocation.id) {
						this.modalOverlay.classList.remove('overlay-background');
						this.$modal.hide('contentModal');
					}
                },
                deep: true
            }
        },
        mounted() {
			if (this.$mq !== 'desktop') {
				this._navigateToGreeting();
				this.$modal.hide('contentModal');
			} else {
				this.setServiceTakeout();
			}
            this.originalLocation = this.location;
            this.modalOverlay = document.querySelector(".v--modal-background-click");

            if (!this.location.id) {
                this.modalOverlay.classList.add('overlay-background');
			}
			this.$tpa.trackInitialSetupPage();
		},
		destroyed() {
			setTimeout(() => {
				EventBus.$emit('new-welcome-modal');
			}, 1000);
		}
    }
</script>


<style lang="scss">
    @import 'globalStyles';

    #back-txt {
        margin-top: 1em;
        display: block;
    }

    .location-detail-section {
        margin-top: 2em;
    }
    #store-locator-section {
        margin-top: 1em;
    }

    .overlay-background {
        background: $overlayBackground;
        background-size: cover;
    }
    .change-store-txt {
        margin-top: 3em;
    }

    .initial-order-body {
        width: 80%;
        margin: 0 auto;
    }

    .modal-logo {
		max-height: 8em;
		max-width: 16em;
		object-fit: contain;
    }

    .login-txt {
        padding: 0.5em;
        position: absolute;
        right: 0;
        top: 0;
    }
    .hide-login {
        height: 0px !important;
        margin-top: 0rem;
        display: none;
    }
    #pinpoint {
        font-size: 3rem;
        padding-top: 0.3em;
    }

    .service-type-section {
        .service-type-label {
            margin-bottom: 2em;
        }
    }

    #initial-order-setup {
        padding-top: 1em;
        height: 100%;
        min-height: 20vh;
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
    }

    #login-section {
        margin-top: 8vh;
    }
    
    .modal-padding {
        padding: 1em;
    }

    .service-type-section {
        .service-icons {
            justify-content: center;
        }
	}
	
	@include mobile {

        .login-txt {
            position: relative;
        }
		#initial-order-setup {
            margin-top: 0em;
            padding-top: 0em;
		}
		.modal-logo {
			max-width: 87%;
		}

        #service-type-header {
            margin-top: 8em;
        }

        .service-type-section {
            .service-icons {
                margin-top: 2em;
            }
		}
		.modal-main-content {
			#initial-order-setup {
				padding-top: $mobileNavigationHeight;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/orders/initial-order-setup/InitialOrderSetup.vue